/*
 * Keep this file separate to avoid import issues.
 */

import {Nux} from '#/state/queries/nuxs'

export const ID = Nux.PolicyUpdate202508
